/// amarildo lacerda
///
/// exemplo:   <mat-select-filial all="false" (change)="mudaFilial($event)"></mat-select-filial>
///


import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ODataBrProvider, ODataBrQuery } from '../services/odatabr.service';
import { Globals } from '../services/globals.service';


@Component({
  selector: 'mat-select-filial',
  template: `
    <mat-form-field>
      <mat-select [(ngModel)]="selected">
        <mat-option *ngFor="let option of options" (click)="doClick($event)" [value]="option.codigo">
          {{ option.nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatSelectFilialComponent),
      multi: true
    }
  ]

})

export class MatSelectFilialComponent implements ControlValueAccessor {
  options: Array<any> = [];
  selected: string;

  _all: string = 'false';
  _todas = { codigo: 0, nome: 'Todas filiais' };

  constructor(
    private oData: ODataBrProvider,
    private globals: Globals) {

  }
  @Input()
  get value() {
    return this.selected;
  }
  set value(x) {
    console.log('Sel: ' + x);
    this.selected = x;
  }
  @Input()
  get all() {
    return this._all;
  }
  set all(x: string) {
    this._all = x;
    if (this._all != 'true') {
      let idx = -1;
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].codigo == 0) {
          idx = i;
          break;
        }
      }
      if (idx >= 0) this.options.splice(idx, 1);
    }
  }

  @Output() change = new EventEmitter();
  propagateChange = (_: any) => { };

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.selected = obj;
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.registerOnTouched = fn;
  };

  doClick(opt) {
    if (this.change != null) {
      this.change.emit(this.selected);
    }
  }

  ngOnInit() {
    this.globals.subscribe(cfg => {
      let query: ODataBrQuery = {
        resource: "filial/usuarios",
        select: ["distinct filial.codigo,filial.nome"],
        top: 200
        //filter: `usuarios.codigo = '${cfg.login.codigo}'`
      }
      //this.oData.
      this.oData.getOData(query).subscribe(fils => {
        if (this._all != 'false') {
          this.options = [this._todas];
        }
        fils.forEach(element => {
          this.options.push(element);
        });
        if (this.selected != null) { this.selected = cfg.config.filial; }
        if (this.change != null) {
          this.change.emit(this.selected);
        }
      })
    });
  }
}
